import { Entity, LobbyGame, Pile, Random } from "~/utils";
import { EffectExecution } from "./EffectExecutionManager2";
import { Game } from "./Game";
import { InfiniteCardPile } from "./InfiniteCardPile";
import { LobbyGameParams } from "./LobbyGameParams";
import { NewPlayerProps, Player } from "./Player";
import { techTiles } from "./TechTile";
import { ActionSlot, ActionSlotDef, actionSlotRepository } from "./actionSlot";
import { BattleCardProps, battleCardsDefRepository } from "./battleCards";
import { CardProps, cardsDefRepository } from "./card";
import { Meaple, PlayerLeader, ResourceType, TurnPhase } from "./constant";
import { playerLeaderRepository } from "./constant/playerLeaders";
import { IntrigueCardProps, intrigueCardsDefRepository } from "./intrigueCards";

const fromLobbyGame = (lobbyGame: LobbyGame) => {
  const {
    settings: { params },
  } = lobbyGame;
  const { useIxExtension = false, useBaseGame = true } = params
    ? LobbyGameParams.fromRecord(params)
    : {};
  const seed = [lobbyGame.id, ...lobbyGame.users.map(({ id }) => id)].join("_");
  Random.setSeed(seed);

  const shopCards = cardsDefRepository.entities.filter(
    (card) => card.shopInstance !== undefined
  );
  let finalBattleCards: (BattleCardProps & Entity)[] =
    battleCardsDefRepository.entities.filter((card) => !card.extension);
  let finalShopCards: (CardProps & Entity)[] = [];
  let actionSlotDefs = actionSlotRepository.entities.filter(
    (slot) => !slot.extension
  );
  let finalLeaders: PlayerLeader[] = [];
  let finalIntrigueCards: (IntrigueCardProps & Entity)[] = [];

  if (useBaseGame) {
    finalLeaders = [
      ...finalLeaders,
      ...playerLeaderRepository.entities.filter((leader) => !leader.extension),
    ];
    finalShopCards = [
      ...finalShopCards,
      ...shopCards.filter((card) => !card.extension),
    ];
    finalIntrigueCards = [
      ...finalIntrigueCards,
      ...intrigueCardsDefRepository.entities.filter((card) => !card.extension),
    ];
  }
  if (useIxExtension) {
    const removedSlots = [
      "Secure contract",
      "Sell melange",
      "Hall of Oratory",
      "Rally Troops",
    ];
    actionSlotDefs = actionSlotDefs
      .filter((slot) => !removedSlots.includes(slot.id))
      .concat(
        actionSlotRepository.entities.filter((slot) => slot.extension === "Ix")
      );
    finalShopCards = [
      ...finalShopCards,
      ...shopCards.filter((card) => card.extension === "Ix"),
    ];
    finalBattleCards = [
      ...finalBattleCards,
      ...battleCardsDefRepository.entities.filter(
        (card) => card.extension === "Ix"
      ),
    ];
    finalLeaders = [
      ...finalLeaders,
      ...playerLeaderRepository.entities.filter(
        (leader) => leader.extension === "Ix"
      ),
    ];
    finalIntrigueCards = [
      ...finalIntrigueCards,
      ...intrigueCardsDefRepository.entities.filter(
        (card) => card.extension === "Ix"
      ),
    ];
  }

  const game = staticNewGame({
    playersProps: lobbyGame.users,
    actionSlotDefs,
    availableLeaders: finalLeaders.filter(
      (leader) =>
        leader.name !== "Ilesa Ecaz" &&
        leader.name !== "Baron Vladimir Harkonnen"
    ),
    battleCardDefs: finalBattleCards,
    intrigueCardDefs: finalIntrigueCards,
    shopCardDefs: finalShopCards,
    useTechTiles: useIxExtension,
    useDreadnoughts: useIxExtension,
  });
  game.players.forEach((player, index) => {
    // player.intrigueCards.push(
    //   intrigueCardsDefRepository.fromName("Poison Snooper")
    // );
    // player.hand.push(cardsDefRepository.fromName("Signet ring"));
    // player.deck.push(cardsDefRepository.fromName("Choam Delegate"));
    // player.resources.add({
    //   [ResourceType.Spice]: 5,
    //   [ResourceType.Solaris]: 6,
    // });
    // player.victoryPoints = 10;
    // ["Bypass Protocol"].forEach((cardName) => {
    //   player.intrigueCards.push(intrigueCardsDefRepository.fromName(cardName));
    // });
    // Object.values(FactionType).forEach((faction) => {
    //   player.getFactionAffinity(faction).level = 3;
    // });
    // player.orbitDreadnought.moveCount(player.combatDreadnought, 1);
    if (index === 0) {
      // player.playerLeader = playerLeaderRepository.findById(
      //   "Prince Rhombur Vernius"
      // )!;
      // player.techTiles.push(techTiles.find((tile) => tile.id === "Artillery")!);
      // player.techTiles.push(
      //   techTiles.find((tile) => tile.id === "Holoprojectors")!
      // );
      // player.techTiles.push(
      //   techTiles.find((tile) => tile.id === "Shuttle Fleet")!
      // );
      // player.techTiles.push(techTiles.find((tile) => tile.id === "Spaceport")!);
      // player.techTiles.push(techTiles.find((tile) => tile.id === "Windtraps")!);
    }
  });
  // actionSlotRepository.entities
  //   .filter((slot) => slot.isControllable)
  //   .forEach((slot) => {
  //     slot.controller = game.players[0].id;
  //   });
  // const battleCardDef = battleCardsDefRepository.entities.find(
  //   (card) => card.name.toLowerCase() === "machinations"
  // )!;
  // const battleCard = battleCardsDefRepository.fromDef(battleCardDef);
  // game.battleDiscard.push(battleCard);

  return game;
};

export type NewGameProps = {
  availableLeaders: PlayerLeader[];
  shopCardDefs: CardProps[];
  battleCardDefs: (BattleCardProps & Entity)[];
  intrigueCardDefs: IntrigueCardProps[];
  actionSlotDefs: ActionSlotDef[];
  playersProps: Pick<NewPlayerProps, "id" | "name">[];
  useTechTiles: boolean;
  useDreadnoughts: boolean;
};

const staticNewGame = ({
  playersProps,
  availableLeaders,
  shopCardDefs,
  battleCardDefs,
  intrigueCardDefs,
  actionSlotDefs,
  useTechTiles = false,
  useDreadnoughts = false,
}: NewGameProps): Game => {
  const { picked: playerLeaders } = Random.takeFrom(
    availableLeaders,
    playersProps.length
  );

  const players = playersProps.map((playerProps, index) => {
    const playerLeader = playerLeaders[index];
    const startingResources = {
      [ResourceType.Water]: 1,
      [ResourceType.Solaris]: 0,
      [ResourceType.Spice]: 0,
    };
    return Player.new({
      ...playerProps,
      playerLeader,
      startingResources,
      dreadnoughtCount: useDreadnoughts ? 2 : 0,
    });
  });
  let shopCards = shopCardDefs.flatMap(({ name, shopInstance = 1 }) => {
    return [...new Array(shopInstance)].map(() =>
      cardsDefRepository.fromName(name)
    );
  });
  shopCards = Random.shuffle(shopCards);

  const lvl1BattleCards = battleCardDefs.filter((card) => card.level === 1);
  const lvl2BattleCards = battleCardDefs.filter((card) => card.level === 2);
  const lvl3BattleCards = battleCardDefs.filter((card) => card.level === 3);
  battleCardDefs = [
    ...Random.takeFrom(lvl1BattleCards, 1).picked,
    ...Random.shuffle(Random.takeFrom(lvl2BattleCards, 5).picked),
    ...Random.shuffle(Random.takeFrom(lvl3BattleCards, 4).picked),
  ];
  // cards are drawn from the end of the array
  battleCardDefs = battleCardDefs.reverse();

  const battleCards = battleCardDefs.map((cardDef) =>
    battleCardsDefRepository.fromDef(cardDef)
  );

  const intrigueCards = Random.shuffle(
    intrigueCardDefs.flatMap((cardDef) =>
      [...new Array(cardDef.instanceCount ?? 1)].map(() =>
        intrigueCardsDefRepository.fromName(cardDef.name)
      )
    )
  );
  const firstPlayerIndex = Random.nextInt(0, players.length - 1);

  const game = new Game({
    players,
    currentPlayerIndex: firstPlayerIndex,
    firstPlayerIndex,
    actionSlots: actionSlotDefs.map((slot) => ActionSlot.from(slot)),
    shop: Pile.fromArray(shopCards.slice(0, 5)),
    shopDeck: Pile.fromArray(shopCards.slice(5)),
    battleDiscard: Pile.empty(),
    battleDeck: Pile.fromArray(battleCards),
    turnPhase: TurnPhase.Play,
    mentatOnSlotOpt: Meaple.new("mentat", undefined),
    intrigueDeck: Pile.fromArray(intrigueCards),
    intrigueDiscard: Pile.empty(),
    effectExecution: EffectExecution.new(),
    skipCleanMentat: false,
    TSMFPile: new InfiniteCardPile({
      cardName: "The spice must flow",
      pile: [],
    }),
    ArrakisLiaisonPile: new InfiniteCardPile({
      cardName: "Arrakis liaison",
      pile: [],
    }),
    infoEvents: [],
    techTiles: useTechTiles ? prepareTechTiles() : [],
    trashedTechTiles: Pile.empty(),
    startTurnSlotWithDreadnought: [],
  });
  game.startGame();
  return game;
};

const prepareTechTiles = () => {
  const shuffledTechTiles = Random.shuffle([...techTiles]);
  const tileSplitSize = shuffledTechTiles.length / 3;
  return [
    Pile.fromArray(shuffledTechTiles.slice(0, tileSplitSize)),
    Pile.fromArray(shuffledTechTiles.slice(tileSplitSize, 2 * tileSplitSize)),
    Pile.fromArray(shuffledTechTiles.slice(2 * tileSplitSize)),
  ];
};

export const NewGame = {
  fromPlayerIds(playerIds: string[]) {
    const lobbyGame: LobbyGame = {
      id: "test",
      started: true,
      settings: {
        minPlayerCount: 2,
        maxPlayerCount: 4,
      },
      users: playerIds.map((id, index) => ({
        id,
        name: `player-${index}`,
      })),
    };
    return fromLobbyGame(lobbyGame);
  },
  fromLobbyGame,
};
